<ng-container *ngIf="sharedDataState$ | async as sharedDataState">
    <div class="mat-elevation-z3">
        <table mat-table [dataSource]="datasource">

            <ng-container matColumnDef="articleNr">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.articleNr.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.articleNr }}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.name.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.costUnitId != null && sharedDataState.costUnitLookup[element.costUnitId]; else byProductName">
                        {{ sharedDataState.costUnitLookup[element.costUnitId].name }}
                    </ng-container>

                    <ng-template #byProductName>
                        <ng-container *ngIf="element.articleId != null && sharedDataState.articleLookup[element.articleId]; else displayPlaceholder">
                            {{ sharedDataState.articleLookup[element.articleId].name }}
                        </ng-container>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.amount.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.amount | number: '1.2-5' : 'de-DE' }}
                </td>
            </ng-container>


            <ng-container matColumnDef="measureUnit">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.measureUnit.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.measureUnitId != null && sharedDataState.measureUnitLookup[element.measureUnitId]; else displayPlaceholder">
                        {{ sharedDataState.measureUnitLookup[element.measureUnitId].shortName }}
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.type.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.costUnitId != null; else byProduct">
                        <button mat-icon-button
                                matTooltip="{{ 'app.page.production-version.actions.navigate-production-version.label' | translate }}"
                                [disabled]="element.productionVersionId == null"
                                (click)="selectArticle(element.productionVersionId)">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </ng-container>
                    <ng-template #byProduct>
                        <mat-icon style="color: gray">close</mat-icon>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="validFrom">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.validFrom.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.validFrom != null; else displayPlaceholder">
                        {{ element.validFrom | date: 'dd.MM.yyyy' }}
                    </ng-container>
                </td>
            </ng-container>


            <ng-container matColumnDef="validTo">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.recipe-article.validTo.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.validTo != null; else displayPlaceholder">
                        {{ element.validTo | date: 'dd.MM.yyyy' }}
                    </ng-container>
                </td>
            </ng-container>


            <ng-template #displayPlaceholder>-</ng-template>

            <tr mat-header-row *matHeaderRowDef="layout.recipeTableColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: layout.recipeTableColumns;"></tr>
        </table>
    </div>
</ng-container>
